export const cooperationTypes = [
  {
    id: 1,
    icon: 'ri-hand-heart-line',
    title: '战略合作',
    description: '与企业建立长期战略合作关系，共同推动公益事业发展，定期组织联合公益活动，提升企业社会责任形象。'
  },
  {
    id: 2,
    icon: 'ri-gift-line',
    title: '物资支持',
    description: '企业提供矿泉水、防暑用品等物资支持，我们负责精准配送到一线工作者手中，确保每一份爱心都能送达。'
  },
  {
    id: 3,
    icon: 'ri-shopping-cart-line',
    title: '公益采购',
    description: '企业通过公益采购方式参与项目，采购物资直接用于一线工作者关怀，实现企业采购与公益事业的完美结合。'
  }
];

export const partnerCases = [
  {
    id: 1,
    name: '重庆农村商业银行',
    logo: 'https://readdy.ai/api/search-image?query=modern%20professional%20bank%20logo%20design%20with%20green%20and%20gold%20colors%2C%20clean%20corporate%20identity%2C%20financial%20institution%20branding%2C%20simple%20geometric%20shapes%2C%20trustworthy%20business%20logo%20on%20white%20background&width=200&height=200&seq=partner-logo-1&orientation=squarish',
    description: '2026年起与我们建立战略合作关系，每年捐赠10万元用于采购矿泉水，覆盖重庆主城区环卫工人群体。',
    photo: 'https://readdy.ai/api/search-image?query=corporate%20charity%20event%20volunteers%20distributing%20bottled%20water%20to%20sanitation%20workers%20in%20Chongqing%20city%2C%20professional%20photography%2C%20warm%20atmosphere%2C%20people%20smiling%2C%20outdoor%20urban%20setting%2C%20bright%20daylight%2C%20community%20service%20activity&width=600&height=400&seq=partner-case-1&orientation=landscape',
    amount: '10万元/年',
    impact: '覆盖5000+环卫工人'
  },
  {
    id: 2,
    name: '重庆百货大楼股份有限公司',
    logo: 'https://readdy.ai/api/search-image?query=elegant%20retail%20department%20store%20logo%20design%20with%20red%20and%20white%20colors%2C%20classic%20shopping%20mall%20branding%2C%20professional%20corporate%20identity%2C%20minimalist%20modern%20style%2C%20premium%20business%20logo%20on%20white%20background&width=200&height=200&seq=partner-logo-2&orientation=squarish',
    description: '通过公益采购方式参与项目，每季度采购5000瓶矿泉水，定向捐赠给商圈周边的快递员和外卖骑手。',
    photo: 'https://readdy.ai/api/search-image?query=delivery%20workers%20and%20couriers%20receiving%20bottled%20water%20donations%20at%20shopping%20district%2C%20corporate%20social%20responsibility%20event%2C%20professional%20photography%2C%20urban%20commercial%20area%2C%20grateful%20expressions%2C%20daytime%20outdoor%20scene&width=600&height=400&seq=partner-case-2&orientation=landscape',
    amount: '2万元/季度',
    impact: '惠及2000+快递骑手'
  },
  {
    id: 3,
    name: '重庆长安汽车股份有限公司',
    logo: 'https://readdy.ai/api/search-image?query=automotive%20company%20logo%20design%20with%20blue%20and%20silver%20colors%2C%20modern%20car%20manufacturer%20branding%2C%20professional%20industrial%20logo%2C%20sleek%20geometric%20design%2C%20corporate%20identity%20on%20white%20background&width=200&height=200&seq=partner-logo-3&orientation=squarish',
    description: '提供物流车辆支持，协助配送矿泉水到各个区县，并组织员工志愿者参与配送活动，践行企业社会责任。',
    photo: 'https://readdy.ai/api/search-image?query=corporate%20volunteers%20loading%20bottled%20water%20into%20delivery%20vehicles%2C%20automotive%20company%20charity%20logistics%20support%2C%20professional%20team%20activity%2C%20warehouse%20setting%2C%20organized%20distribution%2C%20bright%20lighting&width=600&height=400&seq=partner-case-3&orientation=landscape',
    amount: '物流支持',
    impact: '覆盖38个区县'
  },
  {
    id: 4,
    name: '重庆小天鹅火锅',
    logo: 'https://readdy.ai/api/search-image?query=famous%20hotpot%20restaurant%20logo%20design%20with%20red%20and%20gold%20colors%2C%20traditional%20Chinese%20dining%20brand%2C%20elegant%20food%20service%20logo%2C%20cultural%20heritage%20style%2C%20professional%20restaurant%20branding%20on%20white%20background&width=200&height=200&seq=partner-logo-4&orientation=squarish',
    description: '夏季高温期间，为环卫工人和建筑工人提供防暑降温物资，并开放部分门店作为爱心驿站供休息。',
    photo: 'https://readdy.ai/api/search-image?query=restaurant%20staff%20providing%20cooling%20supplies%20and%20water%20to%20construction%20workers%2C%20summer%20heat%20relief%20charity%20program%2C%20caring%20service%20scene%2C%20outdoor%20urban%20setting%2C%20grateful%20workers%2C%20warm%20community%20atmosphere&width=600&height=400&seq=partner-case-4&orientation=landscape',
    amount: '5万元/年',
    impact: '设立20个爱心驿站'
  },
  {
    id: 5,
    name: '重庆燃气集团',
    logo: 'https://readdy.ai/api/search-image?query=utility%20company%20logo%20design%20with%20blue%20and%20orange%20colors%2C%20energy%20service%20provider%20branding%2C%20professional%20infrastructure%20logo%2C%20modern%20corporate%20identity%2C%20clean%20geometric%20design%20on%20white%20background&width=200&height=200&seq=partner-logo-5&orientation=squarish',
    description: '关注一线燃气维修工人，定期捐赠防暑物资，并将公益理念融入企业文化，带动更多员工参与志愿服务。',
    photo: 'https://readdy.ai/api/search-image?query=utility%20workers%20receiving%20heat%20relief%20supplies%20from%20corporate%20donors%2C%20infrastructure%20maintenance%20team%20appreciation%20event%2C%20professional%20photography%2C%20outdoor%20work%20site%2C%20safety%20equipment%20visible%2C%20caring%20gesture&width=600&height=400&seq=partner-case-5&orientation=landscape',
    amount: '3万元/年',
    impact: '惠及800+燃气工人'
  },
  {
    id: 6,
    name: '重庆啤酒股份有限公司',
    logo: 'https://readdy.ai/api/search-image?query=brewery%20company%20logo%20design%20with%20gold%20and%20green%20colors%2C%20beverage%20manufacturer%20branding%2C%20professional%20beer%20industry%20logo%2C%20classic%20corporate%20identity%2C%20premium%20quality%20design%20on%20white%20background&width=200&height=200&seq=partner-logo-6&orientation=squarish',
    description: '每年夏季开展"清凉一夏"公益活动，为户外工作者提供矿泉水和防暑用品，传递企业温度。',
    photo: 'https://readdy.ai/api/search-image?query=beverage%20company%20summer%20charity%20campaign%20distributing%20water%20to%20outdoor%20workers%2C%20corporate%20social%20responsibility%20event%2C%20professional%20photography%2C%20hot%20summer%20day%2C%20workers%20receiving%20supplies%2C%20urban%20outdoor%20setting&width=600&height=400&seq=partner-case-6&orientation=landscape',
    amount: '8万元/年',
    impact: '覆盖3000+户外工作者'
  }
];